import Slider from "react-slick";
import "../../../assets/css/homeBanner.css";
import { Link } from "react-router-dom";

const BannerArrow = ({ className, onClick, direction }) => (
  <button
    type="button"
    className={`${className} home-banner-arrow home-banner-arrow--${direction} flex-center rounded-circle transition-1`}
    onClick={onClick}
    aria-label={direction === "prev" ? "Previous slide" : "Next slide"}
  >
    <i
      className={`ph ${direction === "prev" ? "ph-caret-left" : "ph-caret-right"}`}
    />
  </button>
);

const slides = [
  {
    id: 1,
    subtitle: "Save up to 50% off on your first order",
    titleStart: "Daily Fish Order and Get ",
    titleHighlight: "Express",
    titleEnd: " Delivery",
    // price: "Rs.100",
    image:
      "https://marketpro.theme.picode.in/assets/images/thumbs/banner-img3.png",
  },
  {
    id: 2,
    subtitle: "Fresh seafood delivered every day",
    titleStart: "Premium Fish Delivered to Your ",
    titleHighlight: "Doorstep",
    titleEnd: "",
    // price: "Rs.100",
    image:
      "https://marketpro.theme.picode.in/assets/images/thumbs/banner-img3.png",
  },
];

const sliderSettings = {
  dots: false,
  infinite: slides.length > 1,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  arrows: true,
  prevArrow: <BannerArrow direction="prev" />,
  nextArrow: <BannerArrow direction="next" />,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        dots: false,
      },
    },
  ],
};

const HomeSlider = () => (
  <div className="banner">
    <div className="container container-lg">
      <div className="banner-item rounded-24 overflow-hidden position-relative arrow-center">
        <a
          href="#featureSection"
          className="scroll-down w-84 h-84 text-center flex-center bg-main-600 rounded-circle border border-5 text-white border-white position-absolute start-50 translate-middle-x bottom-0 hover-bg-main-800"
        >
          <span className="icon line-height-0">
            <i className="ph ph-caret-double-down" />
          </span>
        </a>
        <img
          src="https://marketpro.theme.picode.in/assets/images/bg/banner-bg.png"
          alt="Banner background"
          className="banner-img position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 object-fit-cover rounded-24"
        />
        <div className="banner-slider home-banner-slider">
          <Slider {...sliderSettings}>
            {slides.map((slide) => (
              <div key={slide.id}>
                <div
                  className="banner-slider__item"
                  style={{ width: "100%", display: "inline-block" }}
                >
                  <div className="banner-slider__inner flex-between position-relative">
                    <div className="home-banner-desktop-content banner-item__content">
                      <span className="fw-semibold text-success-600 text-capitalize mb-8 animate-left-right animation-delay-08">
                        {slide.subtitle}
                      </span>
                      <h2 className="banner-item__title max-w-700 mb-30 animate-left-right animation-delay-1">
                        {slide.titleStart}
                        <span className="text-main-600">
                          {slide.titleHighlight}
                        </span>
                        {slide.titleEnd}
                      </h2>
                      <div className="d-flex align-items-center gap-16 animate-left-right animation-delay-12">
                        <Link
                          to="/collections"
                          className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8"
                        >
                          Explore Shop
                          <span className="icon text-xl d-flex">
                            <i className="ph ph-shopping-cart-simple" />
                          </span>
                        </Link>
                        {/* <div className="d-flex align-items-end gap-8">
                          <span className="text-heading fst-italic text-sm">
                            Starting at
                          </span>
                          <h6 className="text-danger-600 mb-0">
                            {slide.price}
                          </h6>
                        </div> */}
                      </div>
                    </div>
                    <div className="home-banner-desktop-thumb banner-item__thumb animate-scale animation-delay-12">
                      <img
                        src={slide.image}
                        alt={`${slide.titleStart}${slide.titleHighlight}${slide.titleEnd}`}
                      />
                    </div>
                    <div className="home-banner-mobile">
                      <div className="home-banner-mobile-top">
                        <div className="banner-item__content">
                          <span className="fw-semibold text-success-600 text-capitalize mb-8 animate-left-right animation-delay-08">
                            {slide.subtitle}
                          </span>
                          <h2 className="banner-item__title max-w-700 mb-30 animate-left-right animation-delay-1">
                            {slide.titleStart}
                            <span className="text-main-600">
                              {slide.titleHighlight}
                            </span>
                            {slide.titleEnd}
                          </h2>
                        </div>
                        <div className="banner-item__thumb animate-scale animation-delay-12">
                          <img
                            src={slide.image}
                            alt={`${slide.titleStart}${slide.titleHighlight}${slide.titleEnd}`}
                          />
                        </div>
                      </div>
                      <div className="home-banner-mobile-actions home-banner-mobile-actions--stack animate-left-right animation-delay-12">
                        <Link
                          to="/collections"
                          className="btn btn-main d-inline-flex align-items-center justify-content-center rounded-pill gap-8"
                        >
                          Explore Shop
                          <span className="icon text-xl d-flex">
                            <i className="ph ph-shopping-cart-simple" />
                          </span>
                        </Link>
                        {/* <div className="d-flex align-items-center justify-content-center gap-6 mt-10">
                          <span className="text-heading fst-italic text-xs">
                            Starting at
                          </span>
                          <h6 className="text-danger-600 mb-0">
                            {slide.price}
                          </h6>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  </div>
);

export default HomeSlider;
